import { cn } from "app/lib/utils"
import { getPlayerThickIcon } from "app/player/getPlayerThickIcon"
import type { ToolbarButtonSize } from "app/player/controlSizes"
import PlayerIcon from "./PlayerIcon"
import PlayerIconButton from "./PlayerIconButton"
import { ComponentProps } from "react"

type Props = {
  direction: "back" | "forward"
  disabled?: boolean
  size?: ToolbarButtonSize
  iconSrc?: string
} & Omit<ComponentProps<typeof PlayerIconButton>, "size" | "children">

export default function PlayerSkipButton({
  direction,
  disabled = false,
  size = "lg",
  iconSrc,
  color = "blue",
  className,
  ...props
}: Props) {
  const defaultIconSrc = getPlayerThickIcon(
    color ?? "blue",
    direction === "back" ? "ico_backward_10.svg" : "ico_forward_10.svg"
  )

  return (
    <PlayerIconButton
      size={size}
      color={color}
      disabled={disabled}
      aria-disabled={disabled}
      className={cn(
        disabled &&
          "pointer-events-none cursor-default opacity-20 disabled:opacity-20",
        className
      )}
      {...props}
    >
      <PlayerIcon src={iconSrc ?? defaultIconSrc} size={24} />
    </PlayerIconButton>
  )
}
